import { lazy } from "react"

export const AuthoritiesPage = lazy(() => import("./AuthoritiesPage"))
